import { addCpfMask, convertNumberToLocaleString } from '@repo/ui';
import { StudentWorkloadAchievementRow } from 'domain/models';
import { TableColumn } from 'react-data-table-component';
import { Badge } from 'reactstrap';

type StudentsWorkloadAchievementTableRow = StudentWorkloadAchievementRow & {
  id: string;
};

const formatWorkloadMinutes = (minutes: number): string => {
  if (!minutes && minutes !== 0) return '—';

  const h = Math.floor(minutes / 60)
    .toString()
    .padStart(2, '0');
  const m = (minutes % 60).toString().padStart(2, '0');

  return `${h}:${m}`;
};

const getAchievementVariant = (percent: number): string => {
  if (percent >= 100) return 'success';
  if (percent >= 50) return 'warning';

  return 'danger';
};

const renderAchievementPercent = (percent: number) => (
  <Badge
    className={`bg-${getAchievementVariant(percent)}-subtle text-${getAchievementVariant(percent)}`}
  >
    {convertNumberToLocaleString(percent ?? 0, {
      hasPercentageSymbol: true,
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    })}
  </Badge>
);

export const makeStudentsWorkloadAchievementColumns = (
  studentLegend: string,
): TableColumn<StudentsWorkloadAchievementTableRow>[] => [
  {
    name: <span className="font-weight-bold fs-13">CPF</span>,
    selector: (row) => row.studentCpf,
    cell: (row) => addCpfMask(row.studentCpf) || ' ',
    minWidth: '160px',
  },
  {
    name: <span className="font-weight-bold fs-13">{studentLegend}</span>,
    selector: (row) => row.studentName,
    sortable: true,
    cell: (row) => (
      <span className="text-truncate">{row.studentName || ' '}</span>
    ),
    minWidth: '260px',
  },
  {
    name: <span className="font-weight-bold fs-13">CH REALIZADA</span>,
    selector: (row) => row.performedWorkloadMinutes,
    sortable: true,
    cell: (row) => formatWorkloadMinutes(row.performedWorkloadMinutes),
    minWidth: '130px',
  },
  {
    name: <span className="font-weight-bold fs-13">ALCANÇADO %</span>,
    selector: (row) => row.performedAchievementPercent,
    sortable: true,
    cell: (row) => renderAchievementPercent(row.performedAchievementPercent),
    minWidth: '140px',
  },
  {
    name: <span className="font-weight-bold fs-13">CH VALIDADA</span>,
    selector: (row) => row.validatedWorkloadMinutes,
    sortable: true,
    cell: (row) => formatWorkloadMinutes(row.validatedWorkloadMinutes),
    minWidth: '130px',
  },
  {
    name: <span className="font-weight-bold fs-13">ALCANÇADO %</span>,
    selector: (row) => row.validatedAchievementPercent,
    sortable: true,
    cell: (row) => renderAchievementPercent(row.validatedAchievementPercent),
    minWidth: '140px',
  },
];
